import { render, staticRenderFns } from "./ExcursionHallsTable.vue?vue&type=template&id=43cdbd66&"
import script from "./ExcursionHallsTable.vue?vue&type=script&lang=js&"
export * from "./ExcursionHallsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports